import { FunctionDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const UseApiAction = () => (
  <FunctionDocs entry="useApiAction">
    <ComponentExample
      name="Request on demand"
      description="By default the API action will only execute when explicitly triggered."
      import={import("examples/Api/UseApiAction/RequestOnDemandExample")}
      rawImport={import("examples/Api/UseApiAction/RequestOnDemandExample?raw")}
    />
    <ComponentExample
      name="Request on mount"
      description="useApiAction can optionally trigger the request immediately if required."
      import={import("examples/Api/UseApiAction/RequestOnMountExample")}
      rawImport={import("examples/Api/UseApiAction/RequestOnMountExample?raw")}
    />
    <ComponentExample
      name="Abortable request"
      import={import("examples/Api/UseApiAction/AbortableRequestExample")}
      rawImport={import(
        "examples/Api/UseApiAction/AbortableRequestExample?raw"
      )}
    />
  </FunctionDocs>
);

export default UseApiAction;
